import { Lesson3Player } from "./classes";

const instruments = [
  "melodica",
  "metallophone",
  "snareDrum",
  "tambourine",
  "xylophone",
  "metronome",
];

const lesson3Sounds = [
  {
    name: "ゆっくり",
    urlMap: {
      melodica: [
        `${process.env.PUBLIC_URL}/74/part3.mp3`,
        `${process.env.PUBLIC_URL}/74/part3.wav`,
      ],
      metallophone: [
        `${process.env.PUBLIC_URL}/74/part2.mp3`,
        `${process.env.PUBLIC_URL}/74/part2.wav`,
      ],
      snareDrum: [
        `${process.env.PUBLIC_URL}/74/part5.mp3`,
        `${process.env.PUBLIC_URL}/74/part5.wav`,
      ],
      tambourine: [
        `${process.env.PUBLIC_URL}/74/part4.mp3`,
        `${process.env.PUBLIC_URL}/74/part4.wav`,
      ],
      xylophone: [
        `${process.env.PUBLIC_URL}/74/part1.mp3`,
        `${process.env.PUBLIC_URL}/74/part1.wav`,
      ],
      metronome: [
        `${process.env.PUBLIC_URL}/74/base.mp3`,
        `${process.env.PUBLIC_URL}/74/base.wav`,
      ],
    },
    tempo: 74,
  },
  {
    name: "ふつう",
    urlMap: {
      melodica: [
        `${process.env.PUBLIC_URL}/88/part3.mp3`,
        `${process.env.PUBLIC_URL}/88/part3.wav`,
      ],
      metallophone: [
        `${process.env.PUBLIC_URL}/88/part2.mp3`,
        `${process.env.PUBLIC_URL}/88/part2.wav`,
      ],
      snareDrum: [
        `${process.env.PUBLIC_URL}/88/part5.mp3`,
        `${process.env.PUBLIC_URL}/88/part5.wav`,
      ],
      tambourine: [
        `${process.env.PUBLIC_URL}/88/part4.mp3`,
        `${process.env.PUBLIC_URL}/88/part4.wav`,
      ],
      xylophone: [
        `${process.env.PUBLIC_URL}/88/part1.mp3`,
        `${process.env.PUBLIC_URL}/88/part1.wav`,
      ],
      metronome: [
        `${process.env.PUBLIC_URL}/88/base.mp3`,
        `${process.env.PUBLIC_URL}/88/base.wav`,
      ],
    },
    tempo: 88,
  },
  {
    name: "はやい",
    urlMap: {
      melodica: [
        `${process.env.PUBLIC_URL}/112/part3.mp3`,
        `${process.env.PUBLIC_URL}/112/part3.wav`,
      ],
      metallophone: [
        `${process.env.PUBLIC_URL}/112/part2.mp3`,
        `${process.env.PUBLIC_URL}/112/part2.wav`,
      ],
      snareDrum: [
        `${process.env.PUBLIC_URL}/112/part5.mp3`,
        `${process.env.PUBLIC_URL}/112/part5.wav`,
      ],
      tambourine: [
        `${process.env.PUBLIC_URL}/112/part4.mp3`,
        `${process.env.PUBLIC_URL}/112/part4.wav`,
      ],
      xylophone: [
        `${process.env.PUBLIC_URL}/112/part1.mp3`,
        `${process.env.PUBLIC_URL}/112/part1.wav`,
      ],
      metronome: [
        `${process.env.PUBLIC_URL}/112/base.mp3`,
        `${process.env.PUBLIC_URL}/112/base.wav`,
      ],
    },
    tempo: 112,
  },
];

export const lesson3Player = new Lesson3Player(instruments, lesson3Sounds);
